/**
 * @desc 保存模型
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  modelId: string | number,
  params: API.activiti.activiti.saveModel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activiti/model/${modelId}/save`, {
      method: "PUT",
      params,

      ...options,
    }),
  );
}
